<template>
    <section id="head">
      <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
        <div class="row align-items-center g-lg-5 py-5">
          <div class="col-lg-5 text-center text-lg-start alignFix posRel">
            <div class="assistant">
              <div class="row assHead g-0">
                <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRav1.png"></div>
                <div class="col-8 txt"> Ilaria <div>✈ Servizio Clienti Rimborso al Volo</div>
                </div>
              </div>
              <div class="row assContent g-0">
                <div class="col-2 pic"><img src="https://www.rimborsoalvolo.it/cresources/outform/images/IlariaRimborsoalVolo.jpg"></div>
                <div class="col-10 txt"> ✔️PERFETTO! Richiesta inserita correttamente🤩🤩 Riceverai a breve una nostra comunicazione in merito alla tua pratica.</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 bgWight formStyle posRel" style=" background-color: #e9f2fa;">
            <div class="p-5 text-center thankYou">
              <img src="https://www.rimborsoalvolo.it/cresources/outform/images/dimezzaTempi.png">
              <p class="">Dimezza i tempi di elaborazione della tua pratica!</p>
              <button type="submit" class="btn styleBtn mb-3 float-center" @click="prosegui()">PROCEDI</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <trust-pilot></trust-pilot>
    <conteggio-reclami></conteggio-reclami>
    <recensioni-f-b></recensioni-f-b>
    <sezione-a-p-r-a></sezione-a-p-r-a>
    <page-footer></page-footer>
</template>

<script>
import {useStore} from "vuex";
import {computed} from "vue";
import MessaggioChiusoOK from "@/components/MessaggioChiusoOK";
import {verificaStep} from "@/lib/verificaStep";
import {submitConclusioneInserimentoTicket} from "@/lib/submit";
import FakeChat from "@/components/FakeChat";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";

export default {
  name: "QuintoStep",
  setup() {
    const store = useStore();
    const ticketchiusiokassociati = computed(() => store.state.compilazione.ticketchiusokassociati);
    const s_completati = computed(()=>store.state.compilazione.stepcompletati);
    const s_ticketref = computed(()=>store.state.compilazione.tktref);
    const s_ticketid = computed(()=>store.state.compilazione.ticketid);
    const s_step5_inviato = computed( ()=>store.state.gtmstate.step5inviato);
    return {
      ticketchiusiokassociati,
      s_completati,
      s_ticketref,
      s_ticketid,
      s_step5_inviato,
      setStep5Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio5',true);
      }
    }
  },
  data() {
    return {
      gtm_evt_sent: false,
    }
  },
  mounted() {
    let step = verificaStep([...this.s_completati]);
    if(step.step < 4) this.$router.push(step.url);
    /*let params = "?";
    if(this.getUtmSource !== null && this.getUtmSource !== '') params = params + "utm_source="+this.getUtmSource;

    if(this.getUtmMedium !== null && this.getUtmMedium !== '') params = params + "&utm_medium="+this.getUtmMedium;

    if(this.getUtmCampaign !== null && this.getUtmCampaign !== '') params = params + "&utm_campaign="+this.getUtmCampaign;*/

    // eslint-disable-next-line

    window.scrollTo(0,0);

    if(!this.s_step5_inviato) {
      this.setStep5Inviato();
      this.$gtm.trackEvent({
            event: 'step_visitato',
            value: 5,
          }
      );

      this.$gtm.trackEvent({
        event: 'ticketinserito',
      })

      if(typeof fbq !== 'undefined') {
        fbq('track','PageView');
        fbq('trackCustom','Step5');
        fbq('trackCustom','TicketInserito');
      }

    }


  },
  components: {
    MessaggioChiusoOK,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
    FakeChat,
  },
  methods:{
    prosegui(){
      this.$router.push({name:'step6'});
    }
  }
}
</script>

<style scoped>

</style>